// extracted by mini-css-extract-plugin
export default {"root":"LoginPage_root__f7RWD","header":"LoginPage_header__6fDsm","form-container":"LoginPage_form-container__97BBs","footer":"LoginPage_footer__rD2XZ"};